module.exports = __webpack_public_path__ + "static/assets/1e07ce26fd6d8feb123250b1d96bc6b5.svg";